import React, { Suspense, lazy, useState } from 'react'
import { NavigationContainer } from '@react-navigation/native'
import AppLoading from './src/components/startup/AppLoading'
import { QueryClient, QueryClientProvider } from 'react-query'

import navigationTheme from './src/navigation/navigationTheme'
import LoadingComponent from './src/components/LoadingComponent'
import * as rootNavigation from './src/navigation/rootNavigation'
import { linking } from './src/config/linking'
import StartUpScreen from './src/components/startup/StartUpScreen'
import useWhiteLabel from './src/hooks/useWhiteLabel'
import { useSession } from './src/hooks/useSession'
import TermsAndConditionsGate from './src/components/terms/TermsAndConditionsGate'

const AppNavigator = lazy(() => import('./src/navigation/AppNavigator'))
const AuthNavigator = lazy(() => import('./src/navigation/AuthNavigator'))

const AuthenticatedApp = () => {
  return (
    <TermsAndConditionsGate>
      <Suspense fallback={<LoadingComponent />}>
        <AppNavigator />
      </Suspense>
      <StartUpScreen />
    </TermsAndConditionsGate>
  )
}

export default function AppNavigation() {
  const { isAuthenticated, restoreUser, user } = useSession()
  const [isReady, setIsReady] = useState(false)
  const [queryClient] = useState(() => new QueryClient())
  const { whiteLabel } = useWhiteLabel()

  const handleError = (error) => {
    console.warn(error)
  }

  if (!isReady) {
    return (
      <AppLoading
        startAsync={restoreUser}
        onFinish={() => setIsReady(true)}
        onError={handleError}
      />
    )
  }

  // https://reactnavigation.org/docs/navigation-container/#documenttitleenabled

  return (
    <QueryClientProvider client={queryClient}>
      <NavigationContainer
        theme={navigationTheme}
        linking={linking}
        ref={rootNavigation.navigationRef}
        documentTitle={{
          formatter: (options, route) => whiteLabel?.name ?? 'Loading ...',
        }}
        // onReady={() => {
        //   rootNavigation.isReadyRef.current = true;
        // }}
      >
        {isAuthenticated ? (
          <AuthenticatedApp key={user?.id ?? 'authenticated'} />
        ) : (
          <Suspense fallback={<LoadingComponent />}>
            <AuthNavigator />
          </Suspense>
        )}
      </NavigationContainer>
    </QueryClientProvider>
  )
}
